/**
 * 用于存储账户信息
 */
import {SET_ACCOUNT, RETRIEVE_ACCOUNT} from '../mutation-types'

const state = {
  id: -1,
  name: '',
  username: '',
  photo: '',
  is_male: '',
  birthday: '',
  type: -1,
  nation: '',
  native_place: '',
  political_status: '',
  graduate_school: '',
  major: '',
  edu_bg: '',
  degree: '',
  workplace: '',
  post: '',
  title: '',
  address: '',
  class: ''
}

const mutations = {
  [SET_ACCOUNT] (state, account) {
    Object.keys(account).forEach((key) => {
      state[key] = account[key]
    })
    localStorage.setItem('mba_account', JSON.stringify(account))
  },
  [RETRIEVE_ACCOUNT] (state) {
    let accountStr = localStorage.getItem('mba_account')
    let hasAccount = !!accountStr
    let account = JSON.parse(accountStr)

    if (hasAccount) {
      Object.keys(account).forEach((key) => {
        state[key] = account[key]
      })
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js